import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ChallengeContextService } from '../../contexts/challenge-context/challenge-context.service';
import { CentralDataService } from '../../../streaker-central/services/central-data.service';
import { userProfilePath } from './profile-links';

export interface MyProfileDestination { path: string; challengeId?: number; }
@Injectable({providedIn: 'root'})
export class MyProfileNavigationService {
    constructor(private data: CentralDataService, private security: DwSecurityUserService,
        private challenge: ChallengeContextService, private router: Router) {}
    destination(): Observable<MyProfileDestination> {
        const userId = this.security.securityContext?.ApplicationUser?.UserId;
        const challengeId = this.challenge.currentChallenge?.ChallengeDefinitionId;
        const account = {path: '/account/profile'};
        if (!userId || !challengeId) { return of(account); }
        return this.data.userProfile(userId).pipe(take(1), switchMap(profiles => {
            if (profiles.length !== 1 || !profiles[0].ProfileSlug) { return of(account); }
            const profile = profiles[0];
            return this.data.enrollment(profile.UserProfileId, challengeId).pipe(take(1), switchMap(rows =>
                of(rows.some(row => row.IsRegistrationComplete) ? {path: userProfilePath(profile.ProfileSlug), challengeId} : account)));
        }));
    }
    open(replaceUrl = false): Observable<boolean> {
        return this.destination().pipe(switchMap(target => this.router.navigate([target.path], {
            queryParams: target.challengeId ? {challengeId: target.challengeId} : {}, replaceUrl,
        })));
    }
}
